<div class="ump_mersy_kpi_group_function">
  <div class="row heading-background mt-5">

    <div class="col-lg-6">
      <h4>Mersy KPI Group Function</h4>
    </div>

    <div class="col-lg-6 search-container">

      <input class="form-control" [(ngModel)]="searchString" type="text" (keyup)="treeControl.expandAll()" placeholder="Search" />
      <mat-slide-toggle matTooltip="Show only selected" class="toggle-show-only-selected" [(ngModel)]="showOnlySelected"></mat-slide-toggle>
      <button aria-label="Collapse All" class="btn btn-sm button-fix button-color-fix-orange " (click)="treeControl.collapseAll()">
        <mat-icon class="icon-color-fix">unfold_less</mat-icon>
      </button>
      <button aria-label="Expand All" class="btn btn-sm button-fix button-color-fix-orange " (click)="treeControl.expandAll()">
        <mat-icon class="icon-color-fix">unfold_more</mat-icon>
      </button>
    </div>
  </div>

  <div class="custom_small_panelbody_fix_ghome">
    @if (Tree_Response_State=== 1) {
      <div>
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
          <!-- This is the tree node template for leaf nodes -->
          <mat-nested-tree-node class="mat-tree-node" *matTreeNodeDef="let node"
            matTreeNodeToggle
            [style.display]="showOnlySelected && !node.selected || this.searchString && hideLeafNode(node) ? 'none' : 'block'">
            <li class="mat-tree-node">
              <mat-checkbox class="checklist-leaf-node" (change)="itemToggle($event.checked,node, true);itemSelected($event.checked,node.text,node.id)" [disabled]="node.disabled ||   !node.canAssign " [checked]="node.selected">{{node.text}} </mat-checkbox>
            </li>
          </mat-nested-tree-node>
          <!-- This is the tree node template for expandable nodes -->
          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
            [style.display]="(showOnlySelected && !(node.selected || node.indeterminate)) || this.searchString && hideParentNode(node) ? 'none' : 'block'">
            <li>
              <div class="mat-tree-node">
                <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.text">
                  <mat-icon class="mat-icon-rtl-mirror icon-color-fix">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <mat-checkbox [checked]="node.selected" [disabled]="node.disabled  || !node.canAssign "
                  [indeterminate]="node.indeterminate && !node.selected"
                (change)="itemToggle($event.checked,node, true);itemSelected($event.checked,node.text,node.id)">{{node.text}}</mat-checkbox>
              </div>
              <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      </div>
    }
    @if (Tree_Response_State===-2) {
      <div style=" padding: 20px !important;">
        <div class="blackbg card__desc">
          @for (_ of [].constructor(4); track $index) {
            <div class="card__desc-text"></div>
          }
        </div>
      </div>
    }
  </div>

</div>